import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
var SimpleCarousel = forwardRef(function (_a, ref) {
    var children = _a.children, isHorizontal = _a.isHorizontal, gap = _a.gap, minHeight = _a.minHeight, minWidth = _a.minWidth, onActiveIndexUpdate = _a.onActiveIndexUpdate, _b = _a.autoPlay, autoPlay = _b === void 0 ? false : _b, _c = _a.hideArrows, hideArrows = _c === void 0 ? true : _c, _d = _a.hideDevPanel, hideDevPanel = _d === void 0 ? true : _d, _e = _a.hideInitGap, hideInitGap = _e === void 0 ? true : _e;
    var _f = useState(0), selectedIndex = _f[0], setSelectedIndex = _f[1];
    var _g = useState(isHorizontal), isHorizontalState = _g[0], setIsHorizontal = _g[1];
    var containerRef = useRef();
    var itemRef = useRef();
    var _h = useState(0), left = _h[0], setLeft = _h[1];
    var _j = useState(0), n = _j[0], setN = _j[1]; //no of cards displayed in one time
    // const [gapState, setGap] = useState(gap);
    var _k = useState(0), dim = _k[0], setDim = _k[1];
    var _l = useState(null), touchPosition = _l[0], setTouchPosition = _l[1];
    useImperativeHandle(ref, function () { return ({
        handleNextEvent: function () {
            setSelectedIndex(function (s) { return s + 1; });
        },
        handlePrevEvent: function () {
            setSelectedIndex(function (s) { return s - 1; });
        }
    }); });
    // const [windowWidth, setWindowWidth] = useState(0);
    // const [windowHeight, setWindowHeight] = useState(0);
    var resizeWindow = function () {
        // setWindowWidth(window.innerWidth);
        // setWindowHeight(window.innerHeight);
        recalculate();
    };
    useEffect(function () {
        resizeWindow();
        window.addEventListener('resize', resizeWindow);
        return function () { return window.removeEventListener('resize', resizeWindow); };
    }, []);
    useEffect(function () {
        var interval;
        if (autoPlay) {
            interval = setInterval(function () {
                setSelectedIndex(function (s) { return s + 1; });
            }, 3000);
        }
        else {
            clearInterval(interval);
        }
        return function () {
            clearInterval(interval);
        };
    }, [autoPlay]);
    useEffect(function () {
        setIsHorizontal(isHorizontal);
    }, [isHorizontal]);
    useEffect(function () {
        var x = (100 * gap) / dim;
        if (selectedIndex >= children.length - n && selectedIndex < children.length) {
            setLeft((children.length - n) * (100 + x));
        }
        else if (selectedIndex === children.length) {
            setSelectedIndex(0);
        }
        else if (selectedIndex === -1) {
            setSelectedIndex(children.length - 1);
        }
        else {
            setLeft(selectedIndex * (100 + x));
        }
        onActiveIndexUpdate && onActiveIndexUpdate(selectedIndex);
    }, [selectedIndex, n]);
    useEffect(function () {
        if (containerRef.current) {
            if (isHorizontal) {
                var width = containerRef.current.offsetWidth;
                setN(Math.floor(width / (dim + gap)));
            }
            else {
                var height = containerRef.current.offsetHeight;
                setN(Math.floor(height / (dim + gap)));
            }
        }
    }, [dim]);
    var recalculate = function () {
        if (itemRef.current) {
            if (isHorizontal) {
                var itemWidth = itemRef.current.offsetWidth;
                setDim(itemWidth);
            }
            else {
                var itemHeight = itemRef.current.offsetHeight;
                setDim(itemHeight);
            }
        }
    };
    var handleNext = function () {
        setSelectedIndex(function (s) { return s + 1; });
    };
    var handlePrev = function () {
        setSelectedIndex(function (s) { return s - 1; });
    };
    var handleRadioChange = function (event) {
        if (event.target.value === 'vertical') {
            setIsHorizontal(false);
        }
        else {
            setIsHorizontal(true);
        }
    };
    var handleTouchStart = function (e) {
        var touchDown = e.touches[0].clientX;
        setTouchPosition(touchDown);
        console.log('touchstart');
    };
    var handleTouchMove = function (e) {
        var touchDown = touchPosition;
        console.log('touchDown');
        if (touchDown === null) {
            return;
        }
        var currentTouch = e.touches[0].clientX;
        var diff = touchDown - currentTouch;
        if (diff > 2) {
            handleNext();
        }
        if (diff < -2) {
            handlePrev();
        }
        setTouchPosition(null);
    };
    SimpleCarousel.displayName = 'SimpleCarousel';
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: {
                height: '100%',
                width: '100%'
            } },
            isHorizontalState && (React.createElement("div", { className: 'carousel-container-x', ref: containerRef, style: { minHeight: minHeight, gap: gap } },
                !hideInitGap && React.createElement("div", { style: { width: gap } }),
                children.map(function (Item, key) { return (React.createElement("div", { onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, style: {
                        transform: "translate(-".concat(left, "%)"),
                        // border: selectedIndex === key ? "2px solid black" : "none",
                        borderRadius: 10
                    }, ref: itemRef, key: key }, Item)); }))),
            !isHorizontalState && (React.createElement("div", { className: 'carousel-container-y', ref: containerRef, style: { minWidth: minWidth, gap: gap } },
                !hideInitGap && React.createElement("div", { style: { height: gap } }),
                children.map(function (Item, key) { return (React.createElement("div", { style: {
                        transform: "translateY(-".concat(left, "%)")
                    }, ref: itemRef, key: key }, Item)); })))),
        React.createElement("div", { className: 'carousel-options' },
            !hideArrows && (React.createElement("div", null,
                React.createElement("button", { className: 'previous-button', onClick: handlePrev }, "Previous"),
                React.createElement("button", { className: 'next-button', onClick: handleNext }, "Next"))),
            !hideDevPanel && (React.createElement("div", null,
                "Orientation:",
                React.createElement("div", { onChange: handleRadioChange },
                    React.createElement("input", { type: 'radio', name: 'orientation', value: 'horizontal', defaultChecked: true }),
                    "horizontal",
                    React.createElement("input", { type: 'radio', name: 'orientation', value: 'vertical' }),
                    "vertical"))))));
});
export default SimpleCarousel;
//# sourceMappingURL=SimpleCarousel.js.map